import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import CounsellorHero from '../components/Counsellor/CounsellorHero';
import TopCollegesSection from '../components/Counsellor/TopCollegesSection';
import CounsellorSearchResults from '../components/Counsellor/CounsellorSearchResults';
import PopularSearches from '../components/CollegeFinder/PopularSearches'; 
import CounselorCard from '../components/Counsellor/CounselorCard';
import { useCounsellorDetQuery } from '../store/api/userApiSlice';
import { IoChevronDown } from 'react-icons/io5';
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import './CollegeFinder.css'; 
import './Counsellor.css';

const Counsellor = () => {
  const [searchParams] = useSearchParams();
  const isSearchMode = !!searchParams.get('q');
  
  // Data for landing mode
  const { data, isLoading } = useCounsellorDetQuery();
  const counselors = data?.counsellors || data?.counsellor || data?.data || (Array.isArray(data) ? data : []) || [];

  // State for Load More
  const [visibleCount, setVisibleCount] = useState(12);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 6);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isSearchMode]);

  return (
    <div className="counselor-page">
      <Navbar />
      
      {/* Hero always expands, removed isSearchMode prop */}
      <CounsellorHero />
      
      {isSearchMode ? (
        <>
          <CounsellorSearchResults />
        </>
      ) : (
        /* Landing Mode Layout:
           1. First Batch of Counselors (Grid)
           2. Top MBA Colleges Section (Blue)
           3. Second Batch of Counselors
           4. Footer Actions
        */
        <div className="counselor-landing-content">
            <div className="counselor-landing-grid" style={{ padding: '40px var(--padding-horizontal)' }}>
                <p className="counselor-count-label" style={{ marginBottom: '24px', fontWeight: '500', color: '#666' }}>
                    Search from 100 K+ top career counselors in India.
                </p>
                <div className="counselor-card-grid">
                    {counselors.slice(0, 6).map((counselor) => (
                        <CounselorCard key={counselor._id || counselor.id} counselor={counselor} />
                    ))}
                </div>
            </div>

            <TopCollegesSection />
            
            <div className="counselor-landing-grid" style={{ padding: '60px var(--padding-horizontal)' }}>
                <div className="counselor-card-grid" style={{ marginBottom: '40px' }}>
                    {/* Displaying rest, or a subset based on load more */}
                    {counselors.slice(6, visibleCount).map((counselor) => (
                        <CounselorCard key={counselor._id || counselor.id} counselor={counselor} />
                    ))}
                </div>
                
                <div className="search-footer-actions">
                    {visibleCount < counselors.length && (
                      <button className="load-more-btn" onClick={handleLoadMore}>
                          LOAD MORE <IoChevronDown />
                      </button>
                    )}
                    <button className="back-to-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                        BACK TO TOP <MdKeyboardDoubleArrowUp />
                    </button>
                </div>
            </div>
        </div>
      )}
            
      {!isSearchMode && <PopularSearches />}
      
      <Footer />
    </div>
  );
};

export default Counsellor;
